import { writable } from 'svelte/store'

function createStore() {
    const { subscribe, set, update } = writable([])

    return {
        subscribe,

        set: (data) => {
            set(data)
        },

        add: (data) => {
            update((store) => {
                store.push(data)

                return store
            })
        },

        remove: (moderator) => {
            update((store) => {
                const newStore = store.slice().filter((item) => {
                    return item.username !== moderator.username
                })

                return newStore
            })
        },
    }
}

export const moderatorStore = createStore()
